import { z } from 'zod';

export const IndustryCode = z.nullable(
  z.object({
    tid: z.number().nullable(),
    name: z.string().nullable(),
    industryCode: z.string().nullable(),
  })
);

export type IndustryCode = z.infer<typeof IndustryCode>;
